import get from "lodash/get";
import getConfig from "../config";
import { StateGetterBase } from "./StateGetterBase";

const EMPTY_OBJECT = {}
export class ThemeStateGetter extends StateGetterBase {
    getThemeColor() {
        return get(getConfig(), "hslaAdminThemeColor") || "10, 100%, 27%";
    }
}